import React from 'react';
import { useState } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import Show from './Show';


const Todo = () => {
     const [item, setItem] = useState();
     const [data, setData] = useState([]);

     const ehandler = (e)=>{
          setItem(e.target.value)
     };

     const formSubmit = (e)=>{
           e.preventDefault();
           const newData = item;
           setData([...data, newData])
   setItem('')
     };
     
     const deleteItem =(b)=>{
          const newarr = data.filter((value,index)=>{
               return index !== b;
          })
          setData(newarr)

     }
     return(
<>
<div className="container">
               <div className="row justify-content-center align-items-center main-row">
                    <div className="col shadow main-col bg-white">
                         <div className="row bg-primary text-white">
                              <div className="col  p-2">
                                   <h4 className='text-center'>Todo App Using React JS</h4>
                              </div>
                         </div>
                         <form onSubmit={formSubmit}>
                              <div className="row justify-content-between text-white p-2">
                                   <div className="form-group flex-fill mb-2 col-9">
                                        <input id="todo-input" type="text" className="form-control"  value={item} onChange={ehandler} />
                                   </div>
                                   <button type="submit" className="btn btn-primary mb-2 ml-2 col-3">Add todo</button>
                              </div>
                         </form>
                         {
                              data.map((value,index)=>{
                                 return(
                                   <Show
                                   key={index}
                                   id={index}
                                   task={value}
                                   onSelect={deleteItem}
                                   />
                                 )
                              })
                         }
                    </div>
               </div>
          </div>

     

</>
     )
     
}


export default Todo